import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";

const goToHomepage = (history) => {
	history.push("/");
	window.location.reload(true);
};

const resetApp = (history) => {
	localStorage.clear();
	history.push("/");
	window.location.reload(true);
};

export const UnexpectedErrorFallback = ({eventId}) => {
	const history = useHistory();

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				gap: "10px",
			}}
		>
			<Typography variant="h4">We encountered an unexpected error.</Typography>
			<Typography align="center">
				Refreshing the page, clicking ‘Home’, or ‘Clear Data and Logout’ (before re-login) should resolve the issue.
        <br/>If the issue still persists, please log a call providing the EventID below.
			</Typography>

			<div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
				<Button variant="contained" onClick={() => goToHomepage(history)}>
					Home
				</Button>
				<Button variant="contained" onClick={() => resetApp(history)}>
					Clear Data and Logout
				</Button>
			</div>

      <div style={{ marginTop: "36px"}}>
        <Typography variant="body2">EventID: {eventId}</Typography>
      </div>
		</div>
	);
};
